export function formatResult(value: number): string {
  if (value === 0) return '0';
  const absVal = Math.abs(value);
  let formatted: string;

  if (absVal >= 1e6 || (absVal < 1e-3 && absVal > 0)) {
    formatted = value.toExponential(4);
  } else {
    formatted = value.toPrecision(4);
    if (formatted.indexOf('e') >= 0) {
      formatted = value.toString();
    } else if (formatted.indexOf('.') >= 0) {
      formatted = formatted.replace(/\.?0+$/, '');
    }
  }

  const parts = formatted.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}
